

// Book progression configuration
const BOOKS_CONFIG = [
  {
    id: 'lancet',
    name: 'd\'une édition du \'Lancet\'',
    displayName: 'une édition du \nLancet',
    characters: 50000,
    color: '#28a745', // Green
    description: 'Edition du Lancet (~10 pages)',
    order: 1
  },
  {
    id: 'surf',
    name: 'du \'SURF Guidelines en médecine interne générale\'',
    displayName: 'SURF Guidelines en médecine interne générale',
    characters: 500000,
    color: '#ff007f', // Rose
    description: 'SURF médecine interne (~100 pages)',
    order: 2
  },
  {
    id: 'harrison',
    name: 'du \'Harrison\'s Principles of Internal Medicine\'',
    displayName: 'Harrison\'s Principles of Internal Medicine',
    characters: 5000000,
    color: '#6f42c1', // Purple
    description: 'Harrison\'s Internal Medicine (~1000 pages)',
    order: 3,
    isRepeating: true // This book type repeats for remaining slots
  }
];

// Helper function to get book info based on character count
function getCurrentBookInfo(charactersGenerated) {
  let totalChars = 0;
  let previousTotal = 0;
  
  for (const book of BOOKS_CONFIG) {
    if (book.isRepeating) {
      // For repeating books (Harrison's), calculate which instance we're on
      const remainingChars = charactersGenerated - totalChars;
      const bookNumber = Math.floor(remainingChars / book.characters) + 1;
      const progress = (remainingChars % book.characters) / book.characters;
      
      return {
        ...book,
        bookNumber,
        progress,
        progressPercent: Math.floor(progress * 100),
        isComplete: false
      };
    }
    
    totalChars += book.characters;
    
    if (charactersGenerated < totalChars) {
      // We're currently working on this book
      const progress = (charactersGenerated - previousTotal) / book.characters;
      return {
        ...book,
        bookNumber: 1,
        progress,
        progressPercent: Math.floor(progress * 100),
        isComplete: false
      };
    }
    
    previousTotal = totalChars;
  }
  
  // Should not reach here, but return last book as fallback
  const lastBook = BOOKS_CONFIG[BOOKS_CONFIG.length - 1];
  return {
    ...lastBook,
    bookNumber: 1,
    progress: 1,
    progressPercent: 100,
    isComplete: true
  };
}

// Helper to get books visualization data
function getBooksVisualization(charactersGenerated) {
  const books = [];
  let remainingChars = charactersGenerated;
  
  // First, add non-repeating books
  for (const bookConfig of BOOKS_CONFIG) {
    if (!bookConfig.isRepeating) {
      if (remainingChars >= bookConfig.characters) {
        books.push({ ...bookConfig, fillPercent: 100, filled: true });
        remainingChars -= bookConfig.characters;
      } else if (remainingChars > 0) {
        books.push({ 
          ...bookConfig, 
          fillPercent: (remainingChars / bookConfig.characters) * 100,
          filled: false,
          partial: true
        });
        remainingChars = 0;
      } else {
        books.push({ ...bookConfig, fillPercent: 0, filled: false });
      }
    }
  }
  
  // Then add Harrison's books (repeating)
  const harrison = BOOKS_CONFIG.find(b => b.isRepeating);
  const remainingSlots = 10 - books.length;
  
  for (let i = 0; i < remainingSlots; i++) {
    if (remainingChars >= harrison.characters) {
      books.push({ ...harrison, fillPercent: 100, filled: true });
      remainingChars -= harrison.characters;
    } else if (remainingChars > 0) {
      books.push({ 
        ...harrison, 
        fillPercent: (remainingChars / harrison.characters) * 100,
        filled: false,
        partial: true
      });
      remainingChars = 0;
    } else {
      books.push({ ...harrison, fillPercent: 0, filled: false });
    }
  }
  
  return books;
}

// Format number to k format
function formatToK(number) {
  if (number >= 1000) {
    return (number / 1000).toFixed(1).replace(/\.0$/, '') + 'k';
  }
  return number.toString();
}

// Export all functions
export { 
  getCurrentBookInfo, 
  getBooksVisualization, 
  formatToK,
  BOOKS_CONFIG 
};
